module.exports = __webpack_public_path__ + "staticcomp/img/cover.2f9a205.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/4/cover.jpg
// module id = gJFe
// module chunks = 39